/**
 * A class for all native modules. Extends the [`EventEmitter`](#eventemittertype) class.
 */ export { };

//# sourceMappingURL=NativeModule.js.map
